import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { Campaign } from "../models/Campaign";

type Props = {
	setSelectedRowData: (campaign: Campaign | null) => void;
	setShowModal: (modal: "update" | "delete" | "") => void;
};
export const useCampaignOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Campaign) => {
		let options: MenuOptionType[] = [];
		// options = options.concat([
		// 	{
		// 		name: "New Campaign",
		// 		key: "new_campaign",
		// 		onClick: () => {
		// 			setShowModal("create");
		// 			setSelectedRowData(null);
		// 		},
		// 		icon: <PlaylistAddIcon />,
		// 	},
		// ]);
		if (data) {
			options = options.concat([
				{
					name: "Delete Campaign",
					key: "delete_campaign",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				// {
				// 	name: "Duplicate Campaign",
				// 	key: "duplicate_campaign",
				// 	onClick: () => {
				// 		setSelectedRowData({
				// 			...data,
				// 			CampaignNumber: null,
				// 			Start: new Date(),
				// 			End: null,
				// 			RolledBillets: 0,
				// 			RolledColdTons: 0,
				// 			RolledHotTons: 0,
				// 			IsDuplicate: true,
				// 		});
				// 		setShowModal("create");
				// 	},
				// 	icon: <ContentCopyIcon />,
				// },
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
